// The dashboard's לידים חדשים widget settings — one JSON key (leadsWidget) inside the homepage
// settings blob ($store.state.homepageSettings, homepage_setting.settings on the server).
//
// Shared by DashboardPage (the settings modal + the status column) and EventHandler.syncDashboardLeads
// (which drops a lead from the in-memory list the moment its מצב פניה becomes one the widget hides).
// The status lists mirror SearchResultsService.LEADS_WIDGET_* — the server applies the same rule
// when it builds the list, this only decides what to do with rows already on the client.

export const LEADS_WIDGET_NOT_RELEVANT_STATUSES = ['pniaNotRelevant', 'hazmanaCanceled'];
export const LEADS_WIDGET_IN_PROGRESS_STATUSES = ['pniaInTipul', 'priceOfferSent', 'hazmanaSent', 'hazmanaSigned'];

// defaults = the widget's historical behaviour: only untouched פניות חדשות, no status column
export function normalizeLeadsWidgetSettings(blob) {
    let raw = (blob && blob.leadsWidget) || {};
    return {
        showStatus: raw.showStatus === true,
        hideNotRelevant: raw.hideNotRelevant !== false,
        hideInProgress: raw.hideInProgress !== false
    };
}

// true when a lead whose מצב פניה is `planupSystemStatus` has no place in the widget under `settings`
export function leadsWidgetHides(settings, planupSystemStatus) {
    if (!planupSystemStatus)
        return false;
    if (settings.hideNotRelevant && LEADS_WIDGET_NOT_RELEVANT_STATUSES.includes(planupSystemStatus))
        return true;
    if (settings.hideInProgress && LEADS_WIDGET_IN_PROGRESS_STATUSES.includes(planupSystemStatus))
        return true;
    return false;
}
